import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTimeSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M7.99333 1.33331C4.31333 1.33331 1.33333 4.31998 1.33333 7.99998C1.33333 11.68 4.31333 14.6666 7.99333 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 7.99333 1.33331ZM8 13.3333C5.05333 13.3333 2.66666 10.9466 2.66666 7.99998C2.66666 5.05331 5.05333 2.66665 8 2.66665C10.9467 2.66665 13.3333 5.05331 13.3333 7.99998C13.3333 10.9466 10.9467 13.3333 8 13.3333ZM7.85333 4.66665H7.81333C7.54666 4.66665 7.33333 4.87998 7.33333 5.14665V8.29331C7.33333 8.52665 7.45333 8.74665 7.66 8.86665L10.4267 10.5266C10.6533 10.66 10.9467 10.5933 11.08 10.3666C11.22 10.14 11.1467 9.83998 10.9133 9.70665L8.33333 8.17331V5.14665C8.33333 4.87998 8.12 4.66665 7.85333 4.66665Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
